import { getFormattedDate } from '@/utils/date'

export const getCheckPriceData = ({
  dates,
  selectedCampsite,
  selectedExtras,
  selectedPersons,
}) => {
  return {
    campsites: [
      {
        id: selectedCampsite.id,
        amount: selectedCampsite.amount,
        persons: selectedPersons,
      },
    ],
    date_from: getFormattedDate(dates[0], 'yyyy-MM-dd'),
    date_until: getFormattedDate(dates[1], 'yyyy-MM-dd'),
    extras: selectedExtras,
    discount: selectedCampsite.discount,
  }
}

export const getCheckoutData = ({
  aid,
  billing,
  car,
  dates,
  selectedCampsite,
  selectedExtras,
  selectedPersons,
  travellers,
}) => {
  const checkPriceData = getCheckPriceData({
    dates,
    selectedCampsite,
    selectedExtras,
    selectedPersons,
  })
  const guests = Object.keys(travellers).map(key => {
    const obj = travellers[key]
    return {
      first_name: obj.first_name,
      last_name: obj.last_name,
      birthdate: getFormattedDate(obj.birthdate, 'yyyy-MM-dd'),
    }
  })

  return {
    ...checkPriceData,
    aid: aid,
    city: billing.city,
    country: billing.country.code,
    email: billing.mail,
    first_name: billing.name,
    guests: guests,
    last_name: billing.lastname,
    license_plate: car.license_plate,
    message: billing.message,
    phone: billing.phone,
    street1: billing.street,
    street2: billing.street_additional,
    vehicle_length: car.length,
    vehicle_width: car.width,
    zip_code: billing.zip,
  }
}
